export const getPageStatusColor = (item: any) => {
  if (item.completionRequirements === undefined) return '#FFDC7E';
  switch (item.completionRequirements.value) {
    case 'Optional':
      return '#8ECCFF';
      break;
    case 'Required':
      return '#FFDC7E';
      break;
    case 'Mandatory':
      return '#FF6600';
      break;
    default:
      return '#FF6600';
      break;
  }
};
